import { XStack } from 'tamagui'
import { Switch } from '@/src/common/components/Switch'
import { FormHelpText } from './form-help-text'

type FormToggleProps = {
  label: string
  value: boolean
  onChange: (value: boolean) => void
}

export function FormToggle({ label, value, onChange }: FormToggleProps) {
  return (
    <Switch
      checked={value}
      onCheckedChange={onChange}
      label={{
        render: ({ switchComponent }) => (
          <XStack gap="$2" items="center" maxW="100%">
            {switchComponent}
            <FormHelpText shrink={1} textWrap="wrap">
              {label}
            </FormHelpText>
          </XStack>
        ),
      }}
    />
  )
}
